// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3PpCj","emails":"CreateEditClinics_emails__1bNSq","emailTagLabel":"CreateEditClinics_emailTagLabel__2wcwV"};